import React from 'react';
import { Link } from 'react-router-dom';
import { Button } from '../ui';

// URL strings, never webpack imports — this is what keeps ss's imagery out of
// bm's module graph (build/static/media/ cannot grow).
const IMG = `${process.env.PUBLIC_URL ?? ''}/img/ss`;

/**
 * The web port of jnana-native's SGS Satsang home screen: garland background
 * under a dark gradient, the seated hero, the birthday logo, the title and
 * description, and one Browse CTA. Nothing else — ss has no bhajan of the day,
 * no collections, no babies, and no app promo.
 */
const SsHome: React.FC = () => (
  <main id="main" className="relative isolate overflow-hidden">
    <div
      aria-hidden
      className="absolute inset-0 -z-10 bg-cover bg-center"
      style={{ backgroundImage: `url("${IMG}/garland.png")` }}
    />
    <div
      aria-hidden
      className="absolute inset-0 -z-10"
      style={{ background: 'linear-gradient(#00000022, #00000088)' }}
    />

    <div className="mx-auto flex min-h-[calc(100vh-4rem)] max-w-3xl flex-col items-center justify-center gap-2 px-4 sm:px-6 py-12 text-center">
      <img
        src={`${IMG}/hh-seated.png`}
        alt="Sri Ganapathy Sachchidananda Swamiji"
        width={710}
        height={604}
        className="w-full max-w-[380px] h-auto"
      />
      <img
        src={`${IMG}/hh-birthday-logo.png`}
        alt="80th Birthday Celebrations — Parama Pujya Sri Ganapathy Sachchidananda Swamiji"
        width={600}
        height={600}
        className="w-full max-w-[220px] h-auto"
      />

      <h1 className="text-display font-display font-semibold text-text-primary">SGS Satsang</h1>
      <p className="text-body-lg text-text-primary/90 max-w-xl mb-6">
        Beloved bhajans by various artists—songs about Sri Swamiji and timeless devotional
        favorites.
      </p>

      <Link to="/bhajans" className="w-full max-w-[300px]">
        <Button
          variant="primary"
          size="lg"
          className="w-full"
          style={{ background: 'var(--accent-rose)', color: '#FFFFFF' }}
        >
          Browse
        </Button>
      </Link>
    </div>
  </main>
);

export default SsHome;
